"use client";

import { toast } from "sonner";
import Helper from "@/utils/helper";
import { useAppSelector } from "@/redux/hook";
import { getSettingV2 } from "@/lib/api/shop/setting";
import { usePathname, useRouter } from "next/navigation";
import React, { useEffect, useMemo, useState } from "react";
import useGetSearchParams from "@/lib/hooks/useGetSearchParams";

import SettingApi from "@/common/constants/setting";
import { SortByData } from "@/common/constants/product";
import { ProductSortBy, ProductSortType } from "@/types/Product.type";

type Props = {
  onLoad?: (isLoading: boolean) => void;
};

const ProductFilterSelect = ({ onLoad }: Props) => {
  const router = useRouter();
  const pathname = usePathname();
  const filters: any = useGetSearchParams();
  const [defaultData, setDefaultData] = useState<SortByData>({} as SortByData);
  const [sortByDataProduct, setSortByDataProduct] = useState<SortByData[]>([]);
  const siteLanguage = useAppSelector((state) => state.ShopReducer.language);

  const indexDefault = useMemo(() => {
    return sortByDataProduct.findIndex(
      (item) =>
        item.sort_type === defaultData.sort_type &&
        item.sort_by === defaultData.sort_by
    );
  }, [defaultData.sort_by, defaultData.sort_type, sortByDataProduct]);

  useEffect(() => {
    (async () => {
      try {
        const { data: res } = await getSettingV2(
          SettingApi.KEY.k_setting_items_sort_product,
          {
            lang: siteLanguage.lang,
          }
        );
        const value = res.value as SortByData[];
        setSortByDataProduct(value);
      } catch (error) {
        setSortByDataProduct([]);
      }
    })();
  }, []);

  useEffect(() => {
    if (!sortByDataProduct.length) return;
    if (filters.sort_by && filters.sort_type) {
      setDefaultData({
        sort_by: filters.sort_by as ProductSortBy,
        sort_type: filters.sort_type as ProductSortType,
      });
      return;
    }
    const defaultSort =
      sortByDataProduct.find((item) => item.isDefault) || sortByDataProduct[0];
    setDefaultData(defaultSort);
  }, [filters.sort_by, filters.sort_type, sortByDataProduct]);

  function handelPushParam(data: SortByData) {
    const querysData = Helper.convertFilterToParams({
      ...filters,
      sort_by: data.sort_by,
      sort_type: data.sort_type,
      page: 1,
    });
    router.push(`${pathname}${querysData}`, { scroll: false });
    onLoad?.(true);
  }

  return (
    <div className="flex gap-1 items-center text-base leading-[22px]">
      <span className="text-gray-400">Sắp xếp theo:</span>
      <select
        className="border-none font-semibold text-base focus:outline-none cursor-pointer"
        value={indexDefault}
        onChange={(e) => {
          const index = Number(e.target.value);
          const valueSort = sortByDataProduct?.[index].sort_by;
          const typeSort = sortByDataProduct?.[index].sort_type;

          const data = {
            sort_by: valueSort,
            sort_type: typeSort,
          };
          setDefaultData(data);
          handelPushParam(data);
        }}
      >
        {sortByDataProduct.map((item, index) => {
          return (
            <option
              value={index}
              key={index}
              className="font-normal"
              disabled={item.sort_by === ""}
            >
              {item.name}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default ProductFilterSelect;
